import { PricingResultProduct, RegistrationType } from '@api';
import { CardTable } from '@tsp-ui/core/components';

import styles from './LoanPricingResultCard.module.scss';
import PricingResultProductRow from './PricingResultProductRow';


interface PricingResultProductsTableProps {
    isExpired: boolean;
    onRegister(productID: string, registrationType: RegistrationType): Promise<void>;
    products: PricingResultProduct[];
}

export default function PricingResultProductsTable({
    isExpired, onRegister, products
}: PricingResultProductsTableProps) {
    return (
        <CardTable
            className={styles.productsTable}
            headers={pricingResultTableHeaders}
        >
            {products.map(product => (
                <PricingResultProductRow
                    key={product.productId}
                    product={product}
                    onRegister={onRegister}
                    isExpired={isExpired}
                />
            ))}
        </CardTable>
    );
}

const pricingResultTableHeaders = [
    '',
    'Eligible product',
    'Investor',
    'Margin',
    'Base price',
    'LLPAs',
    'Final price',
    ' '
];
